import type { ComponentProps } from 'react'
import { use } from 'react'

import { cn } from '@gto/ui/cn'

import type { CellAlign, CellPadding } from './table.styles'
import { tableStyles } from './table.styles'
import { TableHeadContext } from './table-context'

/** Renders `<th scope="col">` inside `<Table.Head>`, `<td>` elsewhere. */
export const Cell = ({
  className,
  align = 'left',
  padding = 'none',
  ...props
}: ComponentProps<'td'> & { align?: CellAlign; padding?: CellPadding }) => {
  const isHeadCell = use(TableHeadContext)
  const classes = cn(tableStyles({ align, padding }).cell(), className)

  if (isHeadCell) {
    return (
      <th
        className={classes}
        scope="col"
        {...props}
      />
    )
  }

  return (
    <td
      className={classes}
      {...props}
    />
  )
}
